import { forwardRef } from 'react'

/**
 * Page transition indicator — bottom-center brandmark on a white disc.
 */
const BarbaOverlay = forwardRef<HTMLDivElement>(function BarbaOverlay(_props, ref) {
  return (
    <div ref={ref} className="barba-overlay" aria-hidden="true">
      <div className="barba-badge">
        <svg className="barba-loader" viewBox="0 0 100 100" fill="none">
          <circle className="barba-loader-track" cx="50" cy="50" r="46" />
          <circle className="barba-loader-progress" cx="50" cy="50" r="46" />
        </svg>
        <img
          src="/assets/gigafish-brandmark.svg"
          alt=""
          className="barba-mark"
        />
      </div>
    </div>
  )
})

export default BarbaOverlay
